import RelationshipInfoComponent from './RelationshipAddContainer';

export default RelationshipInfoComponent